import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function C() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('solar_panel_175w');
    const { locale } = useRouter();

    const items = [
        {
            title: 'C_item1_title',
            text: [t('C_item1_text1'), t('C_item1_text2')],
        },
        {
            title: 'C_item2_title',
            text: t('C_item2_text'),
        },
        {
            title: 'C_item3_title',
            text: [t('C_item3_text1'), t('C_item3_text2')],
        },
        {
            title: 'C_item4_title',
            text: [t('C_item4_text1'), t('C_item4_text2')],
        },
    ];

    const IMG_MAP = {
        us: {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124729715/3.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124741063/3_M.jpg',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729241136761/pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729241136537/m.png',
        },
    };
    const IMGS = ['de', 'fr', 'es'].includes(locale) ? IMG_MAP.de : IMG_MAP.us;

    return (
        <div className={`sp-175w-C sp-175w-common ${css['sp-175w-C']}`}>
            <div className="info">
                <p className="subtitle">{t('C_subtitle')}</p>
                <p className="title">{t('C_title')}</p>
                <p className="desc">{t('C_desc')}</p>
            </div>
            <div className="img-box">
                <EFPicture src={IMGS.pc} srcPad={IMGS.h5} srcMobile={IMGS.h5} alt={t('C_title')} />
            </div>
            <div className="box">
                <p className="box-title">{t('C_box_title')}</p>
                <ul className="box-items">
                    {items?.map((item: any, k: number) => (
                        <>
                            {k === 2 && <p className="line" key={k}></p>}
                            <li className={`item item-${k}`} key={k}>
                                <p className="item-title">
                                    {t.rich(item.title, {
                                        b: (text: string) => <span className="b">{text}</span>,
                                    })}
                                </p>
                                {Array.isArray(item?.text) ? (
                                    <ul className="item-lists">
                                        {item?.text?.map((list: any, m: number) => (
                                            <li className="item-list" key={`${k}_${m}`}>
                                                <p className={`bar ${m === 0 ? 'gray' : 'blue'}`}></p>
                                                <p className="item-text">{list}</p>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className="item-text">{item.text}</p>
                                )}
                            </li>
                        </>
                    ))}
                </ul>
            </div>
            <p className="tip">{t('C_tip')}</p>
        </div>
    );
}
